<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ message.title }}</h4>
                  <p>{{ message.content }}</p>
                </div>

                <div class="w-full mb-8 flex flex-inline">
                  <vs-input type="text" label-placeholder="Username" v-model="userIdentity" class="w-full" />
                  <div v-if="loading" id="loader" class="w-12 h-9 mt-5 ml-3">
                    <Loader small />
                  </div>
                </div>
                <vs-button type="border" to="/user/login" class="px-4 w-full md:w-auto" >Back To Login</vs-button>
                <vs-button
                  @click="requestPasswordRecovery"
                  :disabled="loading"
                  class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0 "
                >
                  <div  v-if="loading">
                    Please Wait
                  </div>
                  <div v-else>
                    {{ $t('general.password.recovery') }}
                  </div>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/common-ui/loader-block";

export default {
  components: {
    Loader
  },
  data() {
    return {
      userIdentity: '',
      loading: false,
      message: {
        title: "Recover your password",
        content: "Please enter your email address and we'll send you instructions on how to reset your password."
      }
    }
  },
  methods: {
    requestPasswordRecovery() {
      this.loading = !this.loading;
      if (this.validateUserIdentity()) {
        this.sendPasswordRecoveryRequest(this.userIdentity)
        .then()//console.log(r))
        .catch()
      }
    },
    validateUserIdentity() {
      return true;
    },
    async sendPasswordRecoveryRequest(id) {
      if (!id) {
        // Inform user via UI
        return;
      }

      return await this.$context.axios({
        method: "POST",
        url: this.$context.envs.VUE_APP_AUTH_SERVER + "/forget-password",
        data: {
          id
        }
      });

    }
  }
}
</script>
